export default {
      id: "logo_agency_sm-usage",
      viewBox: "0 0 59 40",
      url: __webpack_public_path__ + "sprite.svg#logo_agency_sm-usage",
      toString: function () {
        return this.url;
      }
    }